import type { TFunction } from 'i18next';

import { Quantity } from './analyzer/types';

import { ORANGE, PRIMARY } from 'constants/colors';

export const groupByKey = (
  quantityData: Quantity['data'],
  key: 'openDuty' | 'category' | 'functionId' | 'isBasePlan',
  t: TFunction
) =>
  quantityData.reduce((arr, item) => {
    const entry = arr.find((entry) => entry[key] === item[key]);
    if (entry) {
      item.periods.forEach(({ periodNr, hours }, i) => {
        const period = entry.periods[i];
        if (period) {
          period.hours += hours;
        } else {
          entry.periods.push({ periodNr, hours });
        }
      });
    } else {
      const functionDescription = item.openDuty ? t('openDuty') : t('planned');
      const functionColor = item.openDuty ? ORANGE : PRIMARY;

      arr.push({
        ...item,
        ...(key === 'openDuty' && { functionDescription, functionColor }),
        periods: item.periods.map(({ hours, periodNr }) => ({
          hours,
          periodNr
        }))
      });
    }

    return arr;
  }, [] as any);
